const BASE_URL = 'https://dash.anghami.com/#/app/my-library';

export { BASE_URL };
